import React from 'react';
import { colors } from '@prisjakt/ui-base';
import T from '@prisjakt/ui-translate';
import {
  IconCloseFilled,
  IconCheckFilled,
  IconQuestionFilled,
} from '@prisjakt/ui/icon';
import * as S from './styles';

interface ColoredIconProps {
  color: string;
}

const ColoredIcon: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ColoredIconProps>
>> = ({ children, color }) => (
  <S.ColoredIconWrapper color={color}>{children}</S.ColoredIconWrapper>
);

export const Yes = () => (
  <ColoredIcon color={colors.lightTheme.positive500}>
    <IconCheckFilled size={18} color="positive500" />
    <T domain="product">property.boolean-yes</T>
  </ColoredIcon>
);

export const No = () => (
  <ColoredIcon color={colors.lightTheme.negative700}>
    <IconCloseFilled size={18} color="negative700" />
    <T domain="product">property.boolean-no</T>
  </ColoredIcon>
);

export const Unknown = () => (
  <ColoredIcon color={colors.lightTheme.base400}>
    <IconQuestionFilled size={18} color="base400" />
  </ColoredIcon>
);

export default ColoredIcon;
